import { all, takeEvery, put, call, select } from 'redux-saga/effects';
import { notification } from 'antd';
import { history } from 'redux/store';
import * as firebase from 'services/firebase';

import { intl } from 'utils/intl';

import { setState, loadCurrentAccountStart, logout as logoutAction } from './actions';

import UserActionTypes from './types';

const mapAuthProviders = {
  firebase: {
    login: firebase.login,
    register: firebase.register,
    currentAccount: firebase.currentAccount,
    logout: firebase.logout,
  },
};

export function* login({ payload }) {
  const { email, password } = payload;

  yield put(setState({ loading: true }));

  const { authProvider } = yield select(state => state.settings);
  const { authorized } = yield select(state => state.user);

  const success = yield call(mapAuthProviders[authProvider].login, email, password);

  if (success) {
    yield put(loadCurrentAccountStart(true));
  }

  if (!success) {
    yield put(setState({ loading: false }));
  }
}

export function* register({ payload }) {
  const { email, password, name } = payload;

  yield put(setState({ loading: true }));

  const { authProvider } = yield select(state => state.settings);

  const success = yield call(mapAuthProviders[authProvider].register, email, password, name);

  if (success) {
    yield put(loadCurrentAccount());

    yield history.push('/');

    notification.success({
      message: 'Succesful Registered',
      description: 'You have successfully registered!',
    });
  }

  if (!success) {
    yield put(setState({ loading: false }));
  }
}

export function* loadCurrentAccount({ payload }) {
  yield put(setState({ loading: true }));

  const { authProvider } = yield select(state => state.settings);

  const response = yield call(mapAuthProviders[authProvider].currentAccount);

  if (response) {
    const isUserAdmin = yield call(firebase.isUserAdmin);

    if (isUserAdmin) {
      const { id, email, name, avatar, role } = response;
      yield put(
        setState({
          id,
          name,
          email,
          avatar,
          role,
          authorized: true,
        }),
      );

      if (payload) {
        history.push('/');
      }
    } else {
      notification.error({
        message: intl.formatMessage({ id: 'user.notification.authorization.error.title' }),
        description: intl.formatMessage({
          id: 'user.notification.authorization.error.description',
        }),
      });
      yield put(logoutAction());
    }
  }

  yield put(setState({ loading: false }));
}

export function* logout() {
  const { authProvider } = yield select(state => state.settings);

  yield call(mapAuthProviders[authProvider].logout);

  yield put(
    setState({
      id: '',
      name: '',
      role: '',
      email: '',
      avatar: '',
      authorized: false,
      loading: false,
    }),
  );
}

export function* deleteUserFacebookData({ payload }) {
  // yield console.log(payload);
  // yield put(setState({ loading: true }));
  // const req = firebase.firebaseFunctions.httpsCallable('')
  // try {
  // } catch (error) {
  // }
  // const { authProvider } = yield select(state => state.settings);
  // const success = yield call(mapAuthProviders[authProvider].login, email, password);
  // if (success) {
  //   yield put(loadCurrentAccountStart());
  //   yield history.push('/');
  // }
  // if (!success) {
  //   yield put(setState({ loading: false }));
  // }
}

export function* sendEmailConfirmationForDeletion({ payload }) {
  yield put(setState({ hasSentEmailToConfirmDeletion: true }));
  yield console.log(payload);
}

export function* grantAdminRole({ payload }) {
  yield put(setState({ isGivingAdminAccess: true }));

  try {
    const grantAdmin = yield firebase.firebaseFunctions.httpsCallable('grantAdminRole');
    yield grantAdmin({ userId: payload });
    yield put(setState({ isGivingAdminAccess: false, hasGivenAdminAccess: true }));
    notification.success({
      message: intl.formatMessage({ id: 'user.notification.success.title' }),
      description: intl.formatMessage({ id: 'user.notification.grantAdminRole.success' }),
    });
  } catch (error) {
    notification.error({
      message: intl.formatMessage({ id: 'user.notification.error.title' }),
      description: intl.formatMessage({ id: 'user.notification.grantAdminRole.error' }),
    });
    yield put(setState({ isGivingAdminAccess: false }));
  }
}

export function* revokeAdminRole({ payload }) {
  yield put(setState({ isGivingAdminAccess: true }));

  try {
    const removeAdminRole = yield firebase.firebaseFunctions.httpsCallable('removeAdminRole');
    yield removeAdminRole({ userId: payload });
    yield put(setState({ isGivingAdminAccess: false, hasGivenAdminAccess: true }));
    notification.success({
      message: intl.formatMessage({ id: 'user.notification.success.title' }),
      description: intl.formatMessage({ id: 'user.notification.removeAdminRole.success' }),
    });
  } catch (error) {
    notification.error({
      message: intl.formatMessage({ id: 'user.notification.error.title' }),
      description: intl.formatMessage({ id: 'user.notification.removeAdminRole.error' }),
    });
    yield put(setState({ isGivingAdminAccess: false }));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(UserActionTypes.LOGIN, login),
    takeEvery(UserActionTypes.REGISTER, register),
    takeEvery(UserActionTypes.LOAD_CURRENT_ACCOUNT, loadCurrentAccount),
    takeEvery(UserActionTypes.LOGOUT, logout),
    takeEvery(UserActionTypes.DELETE_USER_FACEBOOK_DATA, deleteUserFacebookData),
    takeEvery(
      UserActionTypes.SEND_EMAIL_CONFIRMATION_FOR_DELETION,
      sendEmailConfirmationForDeletion,
    ),
    takeEvery(UserActionTypes.GRANT_ADMIN_ROLE, grantAdminRole),
    takeEvery(UserActionTypes.REVOKE_ADMIN_ROLE, revokeAdminRole),
    loadCurrentAccount({ type: UserActionTypes.LOAD_CURRENT_ACCOUNT, payload: false }), // run once on app load to check user auth
  ]);
}
